import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownMenu, DropdownMenuItem, IconButton } from 'seagull';
import { EditSquare, Kebab, LinkIcon } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
export const PresetRowActions = (param)=>{
    let { preset, onEdit, onMapToQbo } = param;
    const { t } = useLocaleKeys('pages.salesTaxSettings.ratesSection.actions');
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        minWidth: 200,
        target: /*#__PURE__*/ _jsx(IconButton, {
            bi: {
                name: 'sales_tax_preset_actions_open'
            },
            children: /*#__PURE__*/ _jsx(Kebab, {})
        }),
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuItem, {
                iconStart: /*#__PURE__*/ _jsx(EditSquare, {}),
                onClick: ()=>onEdit(preset),
                bi: {
                    name: 'sales_tax_preset_edit'
                },
                children: t.edit()
            }),
            /*#__PURE__*/ _jsx(DropdownMenuItem, {
                iconStart: /*#__PURE__*/ _jsx(LinkIcon, {}),
                onClick: ()=>onMapToQbo(preset),
                bi: {
                    name: 'sales_tax_preset_map_qbo'
                },
                children: t.mapToQbo()
            })
        ]
    });
};
